import React, { Component } from 'react';
import { Col, Row, Card, CardBody, CardHeader } from 'reactstrap';
import './index.css';
import { Helmet } from 'react-helmet';
import update from '../../assets/fontawesome/update.png';
import axios from "axios";
import AppContext from '../../AppContext';
const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];

const btoa = require('btoa');
const basicAuth = 'Basic ' + btoa(config.api_credentials);

const instance = axios.create({
  baseURL: config.main_server,
  timeout: 8000,
  headers: {
    'content-type': 'application/json',
    'auth': basicAuth,
  }
});

class TopPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      data: props.data.length ? props.data : []
    }
  }

  componentDidMount() {

    fetch(`/top_competitors`)
      .then(response => response.json())
      .then(res => {
        return this.setState({ data: res });
      })

  }

  render() {

    return (
      <div className="animated fadeIn mainView" style={{ height: '100%' }}>
        <Helmet>

          <title data-react-helmet="true">Top Competitors and Alternatives</title>
          <meta data-react-helmet="true" name="description" content="These are the top visited pages that visitors come in on which include top phrases like competitors and revenue." />
          <meta name="author" content="Growjo" />
        </Helmet>
        <Card style={{ height: '100%' }}>
          <CardHeader style={{ backgroundColor: 'white' }}>
            <img src={update} style={{ float: 'left', marginRight: 13, marginTop: 4 }} /><h1 style={{ color: '#474866', fontSize: 22, marginBottom: 0 }}>
              Top Competitors and Alternatives
            </h1>
          </CardHeader>
          <CardBody>
            <h4 style={{ marginTop: 10, marginBottom: 30, color: 'grey' }}>
              The majority of the Growjo's traffic that is coming in comes from users looking for specific competitors and alternatives of other companies while other traffic is coming from pricing and costs searches.  For example, <a href={'https://www.lead411.com/zoominfo-competitors'} target='_blank'>zoominfo competitors</a> or seamless.ai alternatives or blockfi competitors . We also get a fair amount of traffic from phrases like Zoom IPO, Zoom revenue or Slack revenue growth. Below is a list of the most common looked up companies. By clicking on each you will see a more detailed description of their competitors, pricing, revenue growth, etc.
              </h4>
            <div style={{ margin: '0 15%' }}>
              <Row>
                {this.state.data.map(item =>
                  <Col md={4}>
                    <a href={item.URL}>
                      {item.company_name}
                    </a>
                  </Col>
                )}
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

class TopPageWrapper extends React.Component {
  render() {
    return (
      <TopPage data={this.context || []} />
    )
  }
}
TopPageWrapper.contextType = AppContext;

export default TopPageWrapper;


// WEBPACK FOOTER //
// ./client/src/views/TopPages/index.js